import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "book" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    d: "M12 6.253C13.168 5.477 14.754 5 16.5 5C18.247 5 19.832 5.477 21 6.253V19.253C19.832 18.477 18.247 18 16.5 18C14.754 18 13.168 18.477 12 19.253M12 6.253V19.253V6.253ZM12 6.253C10.832 5.477 9.246 5 7.5 5C5.754 5 4.168 5.477 3 6.253V19.253C4.168 18.477 5.754 18 7.5 18C9.246 18 10.832 18.477 12 19.253V6.253Z",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }